import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c4b007e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_5 = { key: 0 }

import {useStore} from "vuex";
import {computed, onMounted, ref} from "vue";
import {APIURL} from "@/store/config";


import {defineComponent, defineProps} from 'vue'
import {Notyf} from "notyf";

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "UserTableRow"
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['userData'],
  setup(__props) {

const props = __props;


const store = useStore()
const editing = ref(false)
const editedName = ref('')
const editedEmail = ref('')
const imageInput = ref(null)

const toggleEditing = () => {
  editedName.value = props.userData.name
  editedEmail.value = props.userData.email
  editing.value = !editing.value
}

const remove = async (id: number) => {
  if (confirm('Do you want to remove this user?')) {
    //TODO:Create notification to ask if it is really to delete
    try {
      await store.dispatch('deleteUser', id)
      notyf.success(`User removed!`)
    } catch (e) {
      notyf.error(`Error while removing user!`)
    }
  }
}

const save = async () => {


  try {
    await store.dispatch('changeName', {
      name: editedName.value,
      user_id: props.userData.user_id,
    })

    await store.dispatch('changeEmail', {
      email: editedEmail.value,
      user_id: props.userData.user_id,
    })

    await store.dispatch('fetchUsers')

    toggleEditing()
    notyf.success(`User data saved!`)
  } catch (e) {
    notyf.error(`Error changing user data!`)
  }

}

const userImageURL = computed(() => {
  const random = Math.round(99999 * Math.random())
  return `${APIURL}users/image/${props.userData.user_id}/?hash=${random}`
})

const selectFile = () => {
  imageInput.value.click()
}

const uploadImage = async () => {
  try {
    await store.dispatch('uploadUserImage', {
      user_id: props.userData.user_id,
      file: imageInput.value.files[0]
    })

    store.dispatch('fetchUsers')
  } catch (e) {
    notyf.error(`Error uploading image!`)
  }
}

onMounted(() => {

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("th", null, _toDisplayString(__props.userData.user_id), 1),
    _createElementVNode("td", null, [
      _createElementVNode("figure", {
        class: "image is-64x64 pointer",
        onClick: selectFile
      }, [
        _createElementVNode("img", {
          class: "is-rounded",
          src: userImageURL.value,
          alt: "click_to_upload"
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("input", {
        type: "file",
        class: "is-hidden",
        ref_key: "imageInput",
        ref: imageInput,
        onChange: uploadImage
      }, null, 544)
    ]),
    _createElementVNode("td", null, [
      (!editing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.userData.name), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedName).value = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, editedName.value]
          ])
    ]),
    _createElementVNode("td", null, [
      (!editing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.userData.email), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editedEmail).value = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, editedEmail.value]
          ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button is-warning is-small",
                onClick: toggleEditing
              }, _toDisplayString(_ctx.$t('message.edit')), 1))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button is-success is-small",
                onClick: save
              }, _toDisplayString(_ctx.$t('message.save')), 1))
        ]),
        (!editing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "button is-danger is-small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (remove(__props.userData.user_id)))
              }, _toDisplayString(_ctx.$t('message.delete')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})